import ServiceManager from '../../service/ServiceManager';
import { data } from '../../constants/Constants';
import { getDevice } from './utilApi';

export function EliminarProductosCarritoPedido(Dealer, Linea, Asociado, LocalId, PedidoId, Deleted) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "dealer/EliminarProductosCarritoPedido";
    params.data = {
        'dto.CorreoElectronicoDealer': Dealer.correoElectronico,
        'dto.CodigoDealer': Dealer.codcliente,
        'dto.DispositivoDealer': DispositivoId,
        'dto.Linea': Linea.linea,
        'dto.Centro': Linea.centro,
        'dto.Vkorg': Linea.vkorg,
        'dto.Almacen': Linea.almacen,
        'dto.Sector': Linea.sector,
        'dto.Canal': Linea.canal,
        'dto.Moneda': Asociado.moneda,
        'dto.Poblacion': Asociado.poblacion,
        'dto.LocalId': LocalId,
        'dto.PedidoId': PedidoId,
        'dto.Sistema': data.Sistema,
        'dto.Deleted': Deleted
    };
    console.log("EliminarProductosCarritoPedido===>", params.data);
    return ServiceManager.prototype.Post(params);
}
export function ActualizarStockPorLimitesProductoCarritoPedido(Dealer, Linea, Asociado, LocalId, PedidoId, Productos) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "dealer/ActualizarStockPorLimitesProductoCarritoPedido";
    params.data = {
        'dto.CorreoElectronicoDealer': Dealer.correoElectronico,
        'dto.CodigoDealer': Dealer.codcliente,
        'dto.DispositivoDealer': DispositivoId,
        'dto.Linea': Linea.linea,
        'dto.Centro': Linea.centro,
        'dto.Vkorg': Linea.vkorg,
        'dto.Almacen': Linea.almacen,
        'dto.Sector': Linea.sector,
        'dto.Canal': Linea.canal,
        'dto.Moneda': Asociado.moneda,
        'dto.Poblacion': Asociado.poblacion,
        'dto.LocalId': LocalId,
        'dto.PedidoId': PedidoId,
        'dto.ProductosLimite': Productos,
        'dto.Sistema': data.Sistema
    };

    return ServiceManager.prototype.Post(params);
}
export function EliminarProductoCarritoPedido(Dealer, Linea, Asociado, LocalId, PedidoId, ProductoId) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "dealer/EliminarProductoCarritoPedido";
    params.data = {
        'dto.CorreoElectronicoDealer': Dealer.correoElectronico,
        'dto.CodigoDealer': Dealer.codcliente,
        'dto.DispositivoDealer': DispositivoId,
        'dto.Linea': Linea.linea,
        'dto.Centro': Linea.centro,
        'dto.Vkorg': Linea.vkorg,
        'dto.Almacen': Linea.almacen,
        'dto.Sector': Linea.sector,
        'dto.Canal': Linea.canal,
        'dto.Moneda': Asociado.moneda,
        'dto.Poblacion': Asociado.poblacion,
        'dto.LocalId': LocalId,
        'dto.PedidoId': PedidoId,
        'dto.ProductoId': ProductoId,
        'dto.Sistema': data.Sistema
    };
    return ServiceManager.prototype.Post(params);
}
export function ActualizarStockProductoCarritoPedido(Dealer, Linea, Asociado, LocalId, PedidoId, ProductoId, Cantidad) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "dealer/ActualizarStockProductoCarritoPedido";
    params.data = {
        'dto.CorreoElectronicoDealer': Dealer.correoElectronico,
        'dto.CodigoDealer': Dealer.codcliente,
        'dto.DispositivoDealer': DispositivoId,
        'dto.Linea': Linea.linea,
        'dto.Centro': Linea.centro,
        'dto.Vkorg': Linea.vkorg,
        'dto.Almacen': Linea.almacen,
        'dto.Sector': Linea.sector,
        'dto.Canal': Linea.canal,
        'dto.Moneda': Asociado.moneda,
        'dto.Poblacion': Asociado.poblacion,
        'dto.LocalId': LocalId,
        'dto.PedidoId': PedidoId,
        'dto.ProductoId': ProductoId,
        'dto.Cantidad': Cantidad,
        'dto.Sistema': data.Sistema
    };
    console.log("params.data======>", params.data);
    return ServiceManager.prototype.Post(params);
}
export function RegistrarMaterialSustituto(Dealer, Linea, Asociado, LocalId, PedidoId, ProductoId, Producto) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "dealer/RegistrarReemplazo";
    params.data = {
        'dto.CorreoElectronicoDealer': Dealer.correoElectronico,
        'dto.CodigoDealer': Dealer.codcliente,
        'dto.DispositivoDealer': DispositivoId,
        'dto.ProductoId': ProductoId,
        'dto.Codigo': Producto.matnr,
        'dto.Descripcion': Producto.maktx,
        'dto.CantidadOriginal': Producto.cantidad,
        'dto.CantidadPedido': Producto.cantidad,
        'dto.Pantalla': data.Pantalla.Carrito.Sustituto,
        'dto.UnidadMedida': Producto.meins,
        'dto.PrecioFinal': Producto.pfin,
        'dto.PrecioOferta': Producto.pofe,
        'dto.Publico': Producto.ppub,


        'dto.Linea': Linea.linea,
        'dto.Centro': Linea.centro,
        'dto.Vkorg': Linea.vkorg,
        'dto.Almacen': Linea.almacen,
        'dto.Sector': Linea.sector,
        'dto.Canal': Linea.canal,
        'dto.Moneda': Asociado.moneda,
        'dto.Poblacion': Asociado.poblacion,
        'dto.LocalId': LocalId,
        'dto.PedidoId': PedidoId,
        'dto.Cdvped': Linea.cdvped,
        'dto.Sistema': data.Sistema
    };
    console.log("RegistrarMaterialSustituto===>", params.data);
    return ServiceManager.prototype.Post(params);
}
export function ListarMaterialSustituto(Dealer, Linea, Asociado, Matnr) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "dealer/ListarMaterialSustituto";
    params.data = {
        'dto.CorreoElectronicoDealer': Dealer.correoElectronico,
        'dto.CodigoDealer': Dealer.codcliente,
        'dto.DispositivoDealer': DispositivoId,
        'dto.Linea': Linea.linea,
        'dto.Centro': Linea.centro,
        'dto.Vkorg': Linea.vkorg,
        'dto.Almacen': Linea.almacen,
        'dto.Sector': Linea.sector,
        'dto.Canal': Linea.canal,
        'dto.Waers': Asociado.moneda,
        'dto.Pobla': Asociado.poblacion,
        'dto.Matnr': Matnr,
        'dto.Sistema': data.Sistema
    };

    return ServiceManager.prototype.Post(params);
}
export function BuscarCarritoPedido(Dealer, Linea, Asociado, LocalId, PedidoId) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "dealer/BuscarCarritoPedido";
    params.data = {
        'dto.CorreoElectronicoDealer': Dealer.correoElectronico,
        'dto.CodigoDealer': Dealer.codcliente,
        'dto.DispositivoDealer': DispositivoId,
        'dto.Linea': Linea.linea,
        'dto.Centro': Linea.centro,
        'dto.Vkorg': Linea.vkorg,
        'dto.Almacen': Linea.almacen,
        'dto.Sector': Linea.sector,
        'dto.Canal': Linea.canal,
        'dto.Moneda': Asociado.moneda,
        'dto.Poblacion': Asociado.poblacion,
        'dto.LocalId': LocalId,
        'dto.PedidoId': PedidoId,
        'dto.Cdvped': Linea.cdvped,
        'dto.Sistema': data.Sistema
    };
    console.log("BuscarCarritoPedido=====>", params.data);
    return ServiceManager.prototype.Post(params);
}
export function CrearPrePedido(Dealer, Linea, Asociado, LocalId, transporte, contacto, recojo) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "dealer/CrearPrePedido";
    params.data = {
        'dto.CorreoElectronicoDealer': Dealer.correoElectronico,
        'dto.CodigoDealer': Dealer.codcliente,
        'dto.DispositivoDealer': DispositivoId,
        'dto.Linea': Linea.linea,
        'dto.Centro': Linea.centro,
        'dto.Vkorg': Linea.vkorg,
        'dto.Almacen': Linea.almacen,
        'dto.Sector': Linea.sector,
        'dto.Canal': Linea.canal,
        'dto.Moneda': Asociado.moneda,
        'dto.Poblacion': Asociado.poblacion,
        'dto.LocalId': LocalId,
        'dto.Sistema': data.Sistema,

        'dto.Transporte': transporte,
        'dto.Contacto': contacto,
        'dto.Recojo': recojo
    };
    console.log("params.data===>", params.data);
    return ServiceManager.prototype.Post(params);
}
export function CrearPedido(Dealer, Linea, Asociado, LocalId, PedidoId, transporte, contacto, recojo) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "dealer/CrearPedido";
    params.data = {
        'dto.CorreoElectronicoDealer': Dealer.correoElectronico,
        'dto.CodigoDealer': Dealer.codcliente,
        'dto.DispositivoDealer': DispositivoId,
        'dto.Linea': Linea.linea,
        'dto.Centro': Linea.centro,
        'dto.Vkorg': Linea.vkorg,
        'dto.Almacen': Linea.almacen,
        'dto.Sector': Linea.sector,
        'dto.Canal': Linea.canal,
        'dto.Moneda': Asociado.moneda,
        'dto.Poblacion': Asociado.poblacion,
        'dto.LocalId': LocalId,
        'dto.PedidoId': PedidoId,
        'dto.Sistema': data.Sistema,
        'dto.Transporte': transporte,
        'dto.Contacto': contacto,
        'dto.Recojo': recojo



    };
    //  console.log("CrearPedido===>",params.data)
    return ServiceManager.prototype.Post(params);
}
export function AgregarProductoPedido(Dealer,
    Producto,
    Linea,
    Asociado
) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "dealer/RegistrarProducto";
    params.data = {
        'dto.CorreoElectronicoDealer': Dealer.correoElectronico,
        'dto.CodigoDealer': Dealer.codcliente,
        'dto.DispositivoDealer': DispositivoId,
        'dto.Codigo': Producto.codigo,
        'dto.Descripcion': Producto.descripcion,
        'dto.PrecioOferta': Producto.precioOferta,
        'dto.PrecioPublico': Producto.precioPublico,
        'dto.PrecioFinal': Producto.precioFinal,
        'dto.CantidadOriginal': Producto.cantidadOriginal,
        'dto.UnidadMedida': Producto.unidadMedida,
        'dto.Moneda': Producto.moneda,
        'dto.Linea': Linea.linea,
        'dto.Centro': Linea.centro,
        'dto.Vkorg': Linea.vkorg,
        'dto.Almacen': Linea.almacen,
        'dto.Canal': Linea.canal,
        'dto.Sector': Linea.sector,
        'dto.Pantalla': Producto.pantalla,
        'dto.Poblacion': Asociado.poblacion,
        'dto.Sistema': data.Sistema
    };
    console.log("RegistrarProducto====>", params.data);
    return ServiceManager.prototype.Post(params);
}
export function AgregarProductoCarrito(Dealer,
    Linea, Asociado, Producto
) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "dealer/RegistrarProductoCarrito";
    params.data = {
        'dto.CorreoElectronicoDealer': Dealer.correoElectronico,
        'dto.CodigoDealer': Dealer.codcliente,
        'dto.DispositivoDealer': DispositivoId,
        'dto.Codigo': Producto.codigo,
        'dto.Descripcion': Producto.descripcion,
        'dto.PrecioOferta': Producto.precioOferta,
        'dto.PrecioPublico': Producto.precioPublico,
        'dto.PrecioFinal': Producto.precioFinal,
        'dto.CantidadOriginal': Producto.cantidadOriginal,
        'dto.UnidadMedida': Producto.unidadMedida,
        'dto.Moneda': Producto.moneda,
        'dto.Linea': Linea.linea,
        'dto.Centro': Linea.centro,
        'dto.Vkorg': Linea.vkorg,
        'dto.Almacen': Linea.almacen,
        'dto.Canal': Linea.canal,
        'dto.Sector': Linea.sector,
        'dto.Poblacion': Asociado.poblacion,
        'dto.Pantalla': Producto.pantalla,
        'dto.Sistema': data.Sistema
    };
    return ServiceManager.prototype.Post(params);
}
export function AgregarProductoPedidoMasivo(Productos) {
    const DispositivoId = getDevice();

    let ListaProductos = [];

    Productos.filter(function (item) {
        ListaProductos.push({
            "CorreoElectronicoDealer": item.CorreoElectronicoDealer,
            "DispositivoDealer": DispositivoId,
            "Descripcion": item.Descripcion,
            "CantidadOriginal": item.CantidadOriginal,
            "Moneda": item.Moneda,
            "Pantalla": item.Pantalla,
            "Sustituto": item.Sustituto,
            "UnidadMedida": item.UnidadMedida,
            "PrecioFinal": item.PrecioFinal,
            "Codigo": item.Codigo,
            "CodigoDealer": item.CodigoDealer,
            "Centro": item.Centro,
            "Linea": item.Linea,
            "Vkorg": item.Vkorg,
            'Almacen': item.Almacen,
            'Canal': item.Canal,
            'Sector': item.Sector,
            'Sistema': data.Sistema
        });
    });

    let params = {};
    params.url = "dealer/RegistrarProductos";
    params.data = { "listDto": ListaProductos };
    return ServiceManager.prototype.Post(params);
}
export function AgregarNuevoProductoPedidoMasivo(Productos) {
    const DispositivoId = getDevice();

    let ListaProductos = [];

    Productos.filter(function (item) {
        ListaProductos.push({
            "Codigo": item.Codigo,
            "Descripcion": item.Descripcion,
            "CantidadOriginal": item.CantidadOriginal,
            "UnidadMedida": item.UnidadMedida,
            "Sustituto": item.Sustituto,
            'dto.Sistema': data.Sistema
        });
    });



    let params = {};
    params.url = "dealer/RegistrarProductosMasivos";
    params.data = {
        "dto.CorreoElectronicoDealer": Productos[0].CorreoElectronicoDealer,
        "dto.CodigoDealer": Productos[0].CodigoDealer,
        "dto.DispositivoDealer": DispositivoId,
        "dto.Pantalla": Productos[0].Pantalla,
        'dto.Almacen': Productos[0].Almacen,
        'dto.Canal': Productos[0].Canal,
        "dto.Centro": Productos[0].Centro,
        "dto.Linea": Productos[0].Linea,
        "dto.Moneda": Productos[0].Moneda,
        "dto.Vkorg": Productos[0].Vkorg,
        "dto.Sector": Productos[0].Sector,
        'dto.Sistema': data.Sistema,
        "dto.Productos": ListaProductos
    };
    // params.data = { "dto.Productos": ListaProductos };
    console.log("RegistrarProductosMasivos==========>", params.data);
    return ServiceManager.prototype.Post(params);
}